// src/main.tsx
// Application entry point - renders React app to DOM

import React from 'react';
import ReactDOM from 'react-dom/client';
import SphericalColorPaletteExplorer from './SphericalColorPaletteExplorer';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <SphericalColorPaletteExplorer />
  </React.StrictMode>,
);